import { ModuleTypeEnum } from '../types/module-type'
import { CONTACT_QUERY_FIELDS } from './contact-fields'
import { DEAL_QUERY_FIELDS } from './deal-fields'
import { PROJECT_QUERY_FIELDS } from './project-fields'
import { TASK_QUERY_FIELDS } from './task-fields'
import { TICKET_QUERY_FIELDS } from './ticket-fields'
import { QueryFieldDefinition } from './types'

/**
 * Per-module query field registries. To make a module queryable, add its
 * field definitions here (UI autocomplete + validation) and register a
 * translator for it in the API's QueryModule (Prisma translation).
 */
export const QUERY_FIELD_REGISTRY: Partial<
  Record<ModuleTypeEnum, QueryFieldDefinition[]>
> = {
  [ModuleTypeEnum.TASK]: TASK_QUERY_FIELDS,
  [ModuleTypeEnum.TICKET]: TICKET_QUERY_FIELDS,
  [ModuleTypeEnum.PROJECT]: PROJECT_QUERY_FIELDS,
  [ModuleTypeEnum.CONTACT]: CONTACT_QUERY_FIELDS,
  [ModuleTypeEnum.DEAL]: DEAL_QUERY_FIELDS,
}

/** Look up a field definition by key or alias (case-insensitive) */
export function findQueryField(
  fields: QueryFieldDefinition[],
  name: string,
): QueryFieldDefinition | undefined {
  const lower = name.toLowerCase()
  return fields.find(
    field =>
      field.key.toLowerCase() === lower ||
      field.aliases?.some(alias => alias.toLowerCase() === lower),
  )
}

export function getQueryFieldsForModule(
  moduleType: ModuleTypeEnum,
): QueryFieldDefinition[] {
  return QUERY_FIELD_REGISTRY[moduleType] ?? []
}

export function isModuleQueryable(moduleType: ModuleTypeEnum): boolean {
  return Boolean(QUERY_FIELD_REGISTRY[moduleType]?.length)
}

/** Modules that currently support ScQL queries */
export function getQueryableModules(): ModuleTypeEnum[] {
  return Object.keys(QUERY_FIELD_REGISTRY) as ModuleTypeEnum[]
}
